// トラッキングユーティリティ関数
// window.dataLayerにイベントを送信する

interface SearchFilters {
  keyword?: string;
  skill_ids?: number[];
  occupation_ids?: number[];
  industry_ids?: number[];
  characteristic_ids?: number[];
  prefecture_ids?: number[];
  workstyle_types?: string[];
  availability_types?: string[];
  price_over?: number;
  payment_site?: string;
  settlement_hours?: string;
  interview_count_max?: number;
  published_within?: number;
  is_recruiting?: boolean;
  remote_types?: string[];
  workday_types?: string[];
  job_source_ids?: number[];
  sort?: string;
  page?: number;
}

/**
 * 求人検索イベントをdataLayerに送信する
 * @param searchFilters 検索フィルター
 * @param resultsCount 検索結果件数
 */
export const trackJobSearch = (searchFilters: SearchFilters, resultsCount: number): void => {
  if (typeof window === 'undefined' || !window.dataLayer) {
    return;
  }

  // 検索パラメータがあるかどうかを判定（page, sort以外）
  const hasFilters = Object.keys(searchFilters).some(key => {
    if (key === 'page' || key === 'sort') {
      return false;
    }
    const value = searchFilters[key as keyof SearchFilters];
    if (value === undefined || value === null || value === '') {
      return false;
    }
    if (Array.isArray(value) && value.length === 0) {
      return false;
    }
    return true;
  });

  // 検索パラメータがない場合はイベントを送信しない
  if (!hasFilters) {
    return;
  }

  const eventData: Record<string, any> = {
    event: 'job_search_performed',
    search_type: 'client_side',
    results_count: resultsCount,
    has_filters: hasFilters
  };

  // 検索パラメータを追加（値がある場合のみ）
  if (searchFilters.keyword) {
    eventData.keyword = searchFilters.keyword;
  }
  if (searchFilters.skill_ids && searchFilters.skill_ids.length > 0) {
    eventData.skill_ids = searchFilters.skill_ids;
  }
  if (searchFilters.occupation_ids && searchFilters.occupation_ids.length > 0) {
    eventData.occupation_ids = searchFilters.occupation_ids;
  }
  if (searchFilters.industry_ids && searchFilters.industry_ids.length > 0) {
    eventData.industry_ids = searchFilters.industry_ids;
  }
  if (searchFilters.prefecture_ids && searchFilters.prefecture_ids.length > 0) {
    eventData.prefecture_ids = searchFilters.prefecture_ids;
  }
  if (searchFilters.price_over) {
    eventData.price_over = searchFilters.price_over;
  }
  if (searchFilters.sort) {
    eventData.sort = searchFilters.sort;
  }

  window.dataLayer.push(eventData);
};









